import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import * as React from 'react';
import { cn } from './utils/shadcn-utils';
const numericVariants = cva('border border-input-border rounded-md flex items-center transition-colors focus-within:border-ring focus-within:ring-ring/50 focus-within:ring', {
    variants: {
        variant: {
            default: 'bg-input',
            muted: 'bg-muted border-0 focus-within:ring-ring'
        },
        textboxSize: {
            default: 'h-9 px-3 py-2',
            sm: 'h-7 px-1.5 py-0.8',
            lg: 'h-10 px-4 py-2.5'
        }
    },
    defaultVariants: {
        variant: 'default',
        textboxSize: 'default'
    }
});
export const Numeric = React.forwardRef((props, ref) => {
    const { leftSide, rightSide, extendedPlaceholder, className, onChange, autoFocus, placeholder, variant, textboxSize, ...inputProps } = props;
    const [hasValue, setHasValue] = React.useState(() => props.value !== undefined && props.value !== null && String(props.value) !== '');
    const handleChange = (e) => {
        setHasValue(e.target.value !== '');
        const value = isNaN(parseFloat(e.target.value)) ? null : Number(e.target.value);
        onChange?.(value);
    };
    return (_jsxs("div", { className: cn(numericVariants({ variant, textboxSize }), className), children: [leftSide, _jsxs(_Fragment, { children: [extendedPlaceholder && (_jsxs("div", { className: "relative w-full", children: [!hasValue && _jsx("div", { className: "absolute top-1/2 left-2 -translate-y-1/2 pointer-events-none text-muted-foreground", children: extendedPlaceholder }), _jsx("input", { type: "number", className: "w-full h-full bg-transparent relative z-10 outline-none text-foreground placeholder:text-muted-foreground", onChange: handleChange, autoFocus: autoFocus, ref: ref, ...inputProps })] })), !extendedPlaceholder && (_jsx("input", { type: "number", placeholder: placeholder, className: "w-full h-full outline-0 bg-transparent text-foreground placeholder:text-muted-foreground", onChange: handleChange, autoFocus: autoFocus, ref: ref, ...inputProps }))] }), rightSide] }));
});
//# sourceMappingURL=numeric.js.map